<template>
  <div>
    <div @click.stop="hanldeNextStep(currentStep+1)" class="guide-content">
      <!-- 第一步 -->
      <template v-if="currentStep==1">
        <div class="step1-1">
          <img :src="$imgList.guide.pcba['step1-1']">
        </div>
        <div class="step1-2">
          <img :src="$imgList.guide.pcba['step1-2']">
        </div>
        <div class="step1-3">
          <img :src="$imgList.guide.pcba['step1-3']">
        </div>
        <div class="step1-arrow1">
          <img :src="$imgList.guide.pcba['step1-arrow1']">
        </div>
        <div class="step1-arrow2">
          <img :src="$imgList.guide.pcba['step1-arrow2']">
        </div>
        <div class="text-box step1-text">
          <p>Step 1: PCB Upload</p>
          <p>1. Upload your Gerber files</p>
          <p>2. Enter the board dimensions if not auto-filled</p>
          <p>3. Enter the PCB quantity and select the PCB parameters according to your requirements</p>
          <p>&nbsp;&nbsp;</p>
          <div class="guide-btn">
            <span @click.stop="hanldeNextStep(2)">Next</span>
          </div>
        </div>
      </template>

      <!-- 第二步 -->
      <template v-if="currentStep==2">
        <div class="step2-1">
          <img :src="$imgList.guide.pcba['step2-1']">
        </div>
        <div class="step2-2">
          <img :src="$imgList.guide.pcba['step2-2']">
        </div>
        <div class="step2-arrow1">
          <img :src="$imgList.guide.pcba['step2-arrow1']">
        </div>
        <div class="step2-arrow2">
          <img :src="$imgList.guide.pcba['step2-arrow2']">
        </div>
        <div class="text-box step2-text">
          <p>Step 2: PCB Assembly Upload</p>
          <p>1. Upload centroid files</p>
          <p>2. Upload Bill of Materials (BOM) file</p>
          <p>3. Change the PCBA quantity if required</p>
          <p>&nbsp;&nbsp;</p>
          <div class="guide-btn">
            <span @click.stop="handleSkip">Skip</span>
            <span @click.stop="hanldeNextStep(3)">Next</span>
          </div>
        </div>
      </template>

      <!-- 第三步 -->
      <template v-if="currentStep==3">
        <div class="step3-1">
          <img :src="$imgList.guide.pcba['step3-1']">
        </div>
        <div class="step3-2">
          <img :src="$imgList.guide.pcba['step3-2']">
        </div>
        <div class="step3-arrow1">
          <img :src="$imgList.guide.pcba['step3-arrow1']">
        </div>
        <div class="step3-arrow2">
          <img :src="$imgList.guide.pcba['step3-arrow2']">
        </div>
        <div class="text-box step3-text">
          <p>BOM File Upload</p>
          <p>Please refer to the template for an example.</p>
          <p>The BOM file must contain MPN, Quantity and Designator.</p>
          <div class="guide-btn">
            <span @click.stop="handleSkip">Skip</span>
            <span @click.stop="hanldeNextStep(4)">Next</span>
          </div>
        </div>
      </template>

      <!-- 第四步 -->
      <template v-if="currentStep==4">
        <div class="step4-1">
          <img :src="$imgList.guide.pcba['step4-1']">
        </div>
        <div class="step4-2">
          <img :src="$imgList.guide.pcba['step4-2']">
          <div class="bg"></div>
        </div>
        <div class="step4-arrow">
          <img :src="$imgList.guide.pcba['step4-arrow']">
        </div>
        <div class="text-box step4-text">
          <p>Step 3: Quotation</p>
          <p>After uploading the 3 files successfully, the PCBA quotation and lead time will appear here. Click Add to Cart to order.</p>
          <div class="guide-btn">
            <!-- <span @click="handleSkip">Skip</span> -->
            <span @click.stop="hanldeNextStep(5)">Got it</span>
          </div>
        </div>
      </template>

      <!-- 第五步 -->
      <template v-if="currentStep==5">
        <div class="step5-1">
          <img :src="$imgList.guide.pcba['step5-1']">
        </div>
        <div class="step5-arrow">
          <img :src="$imgList.guide.pcba['step5-arrow']">
        </div>
        <div class="text-box step5-text">
          <p>Problems?</p>
          <p>Fear not. Send us an e-mail and our friendly customer service will take care of you.</p>
          <p>&nbsp;&nbsp;</p>
          <div class="guide-btn">
            <span @click.stop="handleFinish">Try it now</span>
          </div>
        </div>
      </template>
    </div>
    <div class="guide-mask" @click.stop="hanldeNextStep(currentStep+1)"></div>
  </div>
</template>

<script>
export default {
  name: 'GuidePcbaQuote',
  data() {
    return {
      currentStep: 1
    }
  },
  methods: {
    hanldeNextStep(nextStep) {
      console.log('nextStep',nextStep)
      if(nextStep>5){
        this.handleFinish()
        return false
      }
      // 需要切换tab
      if ([2,5].includes(nextStep)) {
        this.$emit('handleChangeTab')
      }
      this.currentStep = nextStep
    },
    handleFinish(){
      this.$emit('handleFinishGuide')
    },
    handleSkip() {
      console.log('skip')
      this.$emit('handleFinishGuide')
    }
  }
}
</script>

<style lang="scss" scoped>
img{
  -webkit-user-drag: none;
}
.guide-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 100001;
}

.text-box {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: rgba(242, 242, 242, 1);
  border: none;
  border-radius: 20px;
  box-shadow: none;
  line-height: 24px;
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei UI Bold', 'Microsoft YaHei UI', sans-serif;

  p {
    &:first-child {
      font-weight: 700;
    }
  }

  .guide-btn {
    display: flex;
    justify-content: flex-end;

    span {
      display: block;
      cursor: pointer;
      user-select: none;
      font-weight: 700;
      color: #135ce1;
      &:last-child {
        margin-right: 40px;
      }
    }

    span + span {
      margin-left: 40px;
    }
  }
}

.guide-content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100002;
  user-select: none;

  .step1-1 {
    position: absolute;
    background: transparent;
    left: -4px;
    top: 52px;
  }

  .step1-2 {
    position: absolute;
    top: 139px;
    left: 230px;
  }

  .step1-3 {
    position: absolute;
    top: 504px;
    left: 41px;
  }

  .step1-text {
    width: 353px;
    height: 200px;
    top: 273px;
    left: 65px;
  }

  .step1-arrow1 {
    position: absolute;
    left: 120px;
    top: 200px;
    transform: rotate(-71deg);
  }

  .step1-arrow2 {
    position: absolute;
    left: 400px;
    top: 400px;
    transform: rotate(65deg);
  }

  .step2-1 {
    position: absolute;
    background: transparent;
    left: 196px;
    top: 48px;
  }

  .step2-2 {
    position: absolute;
    top: 123px;
    left: 8px;
  }

  .step2-text {
    width: 349px;
    height: 180px;
    top: -85px;
    left: 476px;
  }

  .step2-arrow1 {
    position: absolute;
    left: 310px;
    top: -10px;
    transform: rotate(161deg);
  }

  .step2-arrow2 {
    position: absolute;
    left: 645px;
    top: 134px;
    transform: rotate(120deg);
  }

  .step3-1 {
    position: absolute;
    background: transparent;
    left: 221px;
    top: 314px;
  }

  .step3-2 {
    position: absolute;
    top: 504px;
    left: 48px;
  }

  .step3-text {
    width: 359px;
    height: 150px;
    top: 509px;
    left: 606px;
  }

  .step3-arrow1 {
    position: absolute;
    left: 575px;
    top: 401px;
    transform: rotate(-128deg);
  }

  .step3-arrow2 {
    position: absolute;
    left: 484px;
    top: 577px;
    transform: rotate(-162deg);
  }

  .step4-1 {
    position: absolute;
    background: transparent;
    right: -2px;
    top: 60px;
  }

  .step4-2 {
    position: absolute;
    top: 104px;
    left: -10px;

    .bg{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      height: 830px;
    }
  }

  .step4-text {
    width: 474px;
    height: 127px;
    top: 551px;
    left: 166px;
  }

  .step4-arrow {
    position: absolute;
    left: 635px;
    top: 608px;
    transform: rotate(17deg);
  }

  .step5-1 {
    position: absolute;
    background: transparent;
    left: 85px;
    top: 216px;
  }

  .step5-text {
    width: 357px;
    height: 160px;
    top: 314px;
    left: 234px;
  }

  .step5-arrow {
    position: absolute;
    left: 145px;
    top: 276px;
    transform: rotate(-71deg);
  }

}
</style>>